import cuid from 'cuid'

export const loadTablePaginationSize = 30

const ALL_COLUMNS = [
  {
    displayName: 'Código',
    name: 'shippingCode',
  },
  {
    displayName: 'Embarcador',
    name: 'shipperName',
  },
  {
    displayName: 'Cidade-UF de Coleta',
    name: 'cityUfCollect',
  },
  {
    displayName: 'Cidade-UF de Entrega',
    name: 'cityUfDelivery',
  },
  {
    displayName: 'Peso',
    name: 'weight',
  },
  {
    displayName: 'Preço',
    name: 'freightPrice',
  },
  {
    displayName: 'Nome do Destinatário',
    name: 'destinationName',
  },
  {
    displayName: 'Nome do Motorista',
    name: 'driverName',
  },
  {
    displayName: 'CPF do Motorista',
    name: 'driverCpf',
  },
  {
    displayName: 'Telefone do Motorista',
    name: 'driverPhone',
  },
  {
    displayName: 'Tipo do Veículo',
    name: 'vehicleType',
  },
  {
    displayName: 'Tipo de Carroceria',
    name: 'bodyType',
  },
  {
    displayName: 'Placas',
    name: 'plates',
  },
  {
    displayName: 'Peso da Carga',
    name: 'loadWeight',
  },
  {
    displayName: 'Cubagem da Carga',
    name: 'loadCubing',
  },
  {
    displayName: 'Valor da Carga',
    name: 'loadPrice',
  },
  {
    displayName: 'Valor do Frete',
    name: 'freightPrice',
  },
  {
    displayName: 'Valor do Pedágio',
    name: 'tollPrice',
  },
  {
    displayName: 'Valor da Descarga',
    name: 'dischargePrice',
  },
  {
    displayName: 'Data de Lançamento',
    name: 'launchDate',
  },
]

export const getQuantityLoads = (state, type) => {
  if (type === 'negotiation') {
    const total =
      state.data.amounts.NORMAL +
      state.data.amounts.QUOTATION +
      state.data.amounts.AUCTION
    return total
  }
  if (type === 'in_progress') {
    const total =
      state.data.amounts.WAIT_BIND_DRIVER +
      state.data.amounts.WAIT_ACCEPT_DRIVER +
      state.data.amounts.BIND_DRIVER +
      state.data.amounts.IN_COLLECT +
      state.data.amounts.IN_TRANSIT +
      state.data.amounts.IN_DELIVERY
    return total
  }
  if (type === 'delivered') {
    const total =
      state.data.amounts.REFUSED +
      state.data.amounts.PENDING +
      state.data.amounts.APPROVED
    return total
  }
}
export default ALL_COLUMNS
